module.exports = __webpack_public_path__ + "img/logo_navbar.9b0fd737.png";